import { ref } from 'vue'

const title = ref('')
const subtitle = ref('')
// 状态类型：'live' | 'completed' | 'scheduled' | ''
const statusType = ref('')
// 是否显示状态标签
const showStatusBadge = ref(false)
// 自定义状态文本
const statusText = ref('')

export function useHeader() {
  /**
   * 设置Header标题
   * @param {string} main - 主标题
   * @param {string} sub - 副标题（可选）
   */
  const setHeader = (main, sub = '') => {
    title.value = main
    subtitle.value = sub
  }

  /**
   * 设置状态类型
   * @param {string} type - 状态类型：'live' | 'completed' | 'scheduled' | ''
   */
  const setStatusType = (type) => {
    statusType.value = type
    showStatusBadge.value = !!type
  }

  /**
   * 设置状态文本
   * @param {string} text - 自定义状态文本
   */
  const setStatusText = (text) => {
    statusText.value = text
  }

  /**
   * 设置是否显示状态标签
   * @param {boolean} show - 是否显示
   */
  const setShowStatusBadge = (show) => {
    showStatusBadge.value = show
  }

  /**
   * 清除Header所有状态
   */
  const clearHeader = () => {
    title.value = ''
    subtitle.value = ''
    statusType.value = ''
    showStatusBadge.value = false
    statusText.value = ''
  }

  return {
    // 状态
    title,
    subtitle,
    statusType,
    showStatusBadge,
    statusText,

    // 方法
    setHeader,
    setStatusType,
    setStatusText,
    setShowStatusBadge,
    clearHeader,
  }
}

export default useHeader
